import { Box, Chip, MenuItem, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));
const MultipleRequirements = ({ value, allValue, setValue, title, preValue }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [pre, setPre] = useState([]);

  const handleChange = e => {
    setPre([]);
    let exist = selected.some(u => u.id === e.id);
    if (!exist) {
      let old = [...selected, e];
      setSelected(old);
      let ids = [];
      old.map(item => {
        ids.push(item.id);
      });
      setValue(ids);
    }
  };
  const deleteOne = e => {
    let items = selected.filter(item => item.id != e.id);
    setSelected(items);
    let ids = [];
    items.map(item => {
      ids.push(item.id);
    });
    setValue(ids);
  };

  // useEffect(() => {
  //   setSelected([]);
  // }, [clearCountry]);

  useEffect(() => {
    setPre(preValue);
  }, []);

  return (
    <Box>
      <TextField
        variant="outlined"
        select
        label={title}
        size="small"
        fullWidth
        required
        value={value}
        onChange={e => handleChange(e.target.value)}
        className={classes.inputStyle}>
        {allValue.map((e, index) => (
          <MenuItem value={{ id: e.id, name: e.title }} key={index}>
            <Box className={classes.inner}>{e.title}</Box>
          </MenuItem>
        ))}
      </TextField>
      <Box sx={{ py: 1, display: 'flex', gap: '15px' }}>
        {selected.map(e => (
          <Chip color="info" icon={<CloseIcon />} label={e.name} onClick={i => deleteOne(e)} className={classes.chip} />
        ))}
      </Box>

      {pre && (
        <Box sx={{ pb: 2, display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <Typography>Previous Requirements:</Typography>
          {pre && pre.map(e => <Chip color="info" label={e.title} className={classes.chip} />)}
        </Box>
      )}
    </Box>
  );
};

export default MultipleRequirements;
